import { C } from './whoop-theme';

/** The 36×20 pill toggle used for settings signals and privacy rows. */
export function ToggleSwitch({ on }: { on: boolean }) {
  return (
    <span
      style={{
        width: 36,
        height: 20,
        borderRadius: 11,
        background: on ? C.accent : 'rgba(255,255,255,0.12)',
        position: 'relative',
        transition: 'background .2s',
        flex: 'none',
        display: 'inline-block',
      }}
    >
      <span
        style={{
          position: 'absolute',
          top: 2,
          left: 0,
          transform: `translateX(${on ? '18px' : '2px'})`,
          width: 16,
          height: 16,
          borderRadius: '50%',
          background: '#fff',
          transition: 'transform .2s',
        }}
      />
    </span>
  );
}
